import React from 'react';
import { useIntl } from 'react-intl';
import { StreamingTrackSourceNumbers } from 'fym-shared/src/music24/streaming';
import { TypedMemo } from '../../../common/types';
import { formatStreamingNumber } from '../streamingFormat';
import { sourceLook } from '../streamingSources';
import { streamingTotalLabels } from '../streamingTotalsMessages';
import { streamingBlockMessages as messages } from '../streamingBlockMessages';
import { SourceMark } from './SourceMark';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface TrackSourcesTableProps {
  bySource: StreamingTrackSourceNumbers[];
}

/**
 * "What each source reports" (design d2): the numbers of each source side by side. They are not
 * added: a distributor already counts the streams of a portal.
 */
const TrackSourcesTableComponent: React.FC<TrackSourcesTableProps> = ({ bySource }) => {
  const intl = useIntl();
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>{intl.formatMessage(messages.colSource)}</th>
          <th className={styles.numCell}>{intl.formatMessage(streamingTotalLabels.streams)}</th>
          <th className={styles.numCell}>{intl.formatMessage(streamingTotalLabels.listeners)}</th>
          <th className={styles.numCell}>{intl.formatMessage(streamingTotalLabels.saves)}</th>
        </tr>
      </thead>
      <tbody>
        {bySource.map((one) => (
          <tr key={one.integrationType}>
            <td>
              <span className={styles.tileFrom}>
                <SourceMark integrationType={one.integrationType} />
                {sourceLook(one.integrationType).name}
              </span>
            </td>
            <td className={styles.numCell}>{formatStreamingNumber(intl, one.streams)}</td>
            <td className={styles.numCell}>{formatStreamingNumber(intl, one.listeners)}</td>
            <td className={styles.numCell}>{formatStreamingNumber(intl, one.saves)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export const TrackSourcesTable = TypedMemo(TrackSourcesTableComponent);
